import urlApi from '../../router/urlApi'
import { Serialize } from '../../services/serializeFormData'
import { LoadFormData } from '../../services/LoadFormData'
import Vue from 'vue'
import Toast from 'vue-toasted'
import router from '../../router'

const toastOptions = {
  theme: 'none',
  position: 'bottom-center',
  className: 'vuestic-toast',
  iconPack: 'fontawesome',
  duration: 5000
}

Vue.use(Toast, toastOptions)
export default {

  store () {
    let self = this

    self.disableButtons(true)

    Vue.http.post(urlApi + '/instrutores', Serialize.toObject('form_instrutores')).then((response) => {
      if (response.status === 200) {
        self.launchToast('fa-check', response.data.mensagem)
        self.pageListarInstrutores()
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    }).catch((response) => {
      if (response.status === 422) {
        Object.keys(response.data.errors).forEach(function (key) {
          self.launchToast('fa-warning', response.data.errors[key][0])
        })
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    })
  },

  update (idInstrutores) {
    let self = this
    self.disableButtons(true)
    Vue.http.patch(urlApi + '/instrutores/' + idInstrutores, Serialize.toObject('form_instrutores')).then((response) => {
      if (response.status === 200) {
        self.launchToast('fa-check', response.data.mensagem)
        self.pageListarInstrutores()
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    }).catch((response) => {
      if (response.status === 422) {
        Object.keys(response.data.errors).forEach(function (key) {
          self.launchToast('fa-warning', response.data.errors[key][0])
        })
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    })
  },

  searchCep (cep) {
    let self = this
    Vue.http.get(urlApi + '/enderecos/' + cep).then((response) => {
      if (response.status === 200 && response.data.sucesso) {
        document.getElementById('logradouro').value = response.data.dados.logradouro
        document.getElementById('cidade').value = response.data.dados.municipio
        document.getElementById('uf').value = response.data.dados.uf
        document.getElementById('bairro').value = response.data.dados.bairro
      } else {
        document.getElementById('logradouro').value = ""
        document.getElementById('cidade').value = ""
        document.getElementById('uf').value = ""
        document.getElementById('bairro').value = ""
      }
    }).catch((response) => {
      // self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      document.getElementById('logradouro').value = ""
      document.getElementById('cidade').value = ""
      document.getElementById('uf').value = ""
      document.getElementById('bairro').value = ""
    })
  },

  atualizaStatus: function (idInstrutores, status, callback) {
    let self = this

    Vue.http.post(urlApi + '/instrutores/' + idInstrutores + '/' + status, []).then(function (response) {
      if (response.data.sucesso) {
        self.launchToast('fa-check', 'Status atualizado!')
      } else {
        self.launchToast('fa-check', 'Erro ao tentar atualizar o status!')
      }
      callback()
    })
  },

  getInstrutorById: function (idInstrutores, callback) {
    Vue.http.get(urlApi + '/instrutores/' + idInstrutores).then(function (response) {
      callback(response)
    })
  },

  pageListarInstrutores () {
    router.push({ name: 'listagem-instrutores' })
  },

  paginaEdicao (idInstrutor) {
    router.push({ name: 'editar-instrutor', params: { idInstrutor: idInstrutor } })
  },

  carregaFormularioDeEdicao (idInstrutores) {
    Vue.http.get(urlApi + '/instrutores/' + idInstrutores).then((response) => {
      LoadFormData.byIdInputs(response.data.dados)
      LoadFormData.byIdInputs(response.data.dados.endereco_instrutor)
      LoadFormData.byIdInputs(response.data.dados.endereco_instrutor.endereco)
    })
  },

  getCategoria (callback) {
    Vue.http.get(urlApi + '/categorias').then((response) => {
      callback(response.data)
    })
  },

  disableButtons (status) {
    document.getElementById('btn_salvar').disabled = status
    document.getElementById('btn_limpar').disabled = status
  },

  launchToast (icon, msg) {
    Vue.toasted.show(msg, {
      icon: icon,
      position: 'top-right',
      duration: 5000,
      fullWidth: false
    }
    )
  },

  getTurmaById: function (idTurma, callback) {
    Vue.http.get(urlApi + '/turmas/' + idTurma).then(function (response) {
      callback(response)
      console.log(response.data.dados)
    })
  },
}
